export const FOOD_PREORDER_EVENT_REPORT_REQUEST =
  "FOOD_PREORDER_EVENT_REPORT_REQUEST";
export const FOOD_PREORDER_EVENT_REPORT_SUCCESS =
  "FOOD_PREORDER_EVENT_REPORT_SUCCESS";
export const FOOD_PREORDER_EVENT_REPORT_FAIL =
  "FOOD_PREORDER_EVENT_REPORT_FAIL";
